import React from "react";

import { HiDotsVertical } from "react-icons/hi";
import { GiPayMoney } from "react-icons/gi";
import { formatCurrencyOnly } from "helper/tools";
import CobranzaConciliacionProductosCell from "./CobranzaConciliacionProductosCell";

function CobranzaConciliacionClientesCell({
  cobranzaItem,
  interestItems,
  index,
  toggleDetails,
  //  children,
  tDetalleRef,
  tDetalleIsShownRef,
  abonarProducto,
  abonarCliente,
}) {
  let clienteCellItem = null;
  if (cobranzaItem) {
    clienteCellItem = cobranzaItem?.clienteCellItem;
  } else if (interestItems) {
    clienteCellItem = interestItems?.clienteCellItem;
  }

  let {
    nombre,
    clienteAbonoQuincenal,
    clienteNoAbono,
    clienteTotalAbonado,
    clienteTotalPendiente,
    clientePagoQuincena,
    clienteNuevoSaldo,
    clienteComision,
    //clienteAbonoAdicional,
    productoParcialidadesItems,
  } = clienteCellItem ?? {};
  //let nombre = "";
  let disableClienteAbonar = false;

  clienteAbonoQuincenal = formatCurrencyOnly(clienteAbonoQuincenal);

  clienteNoAbono = formatCurrencyOnly(clienteNoAbono);

  clienteTotalAbonado = formatCurrencyOnly(clienteTotalAbonado);
  clienteTotalPendiente = formatCurrencyOnly(clienteTotalPendiente);
  clientePagoQuincena = formatCurrencyOnly(clientePagoQuincena);
  clienteNuevoSaldo = formatCurrencyOnly(clienteNuevoSaldo);
  clienteComision = formatCurrencyOnly(clienteComision);

  const displayDetalle = {
    display: tDetalleIsShownRef.current[index] ? "table-row" : "none",
  };

  return (
    <>
      <tr
        className="conciliacion-table table-secondary"
        key={index}
        onClick={(event) => toggleDetails?.(index, cobranzaItem?.id)}
        style={{
          fontWeight: tDetalleIsShownRef.current[index] ? "bold" : "normal",
          backgroundColor: tDetalleIsShownRef.current[index]
            ? "#C1E6EC"
            : "white",
        }}
      >
        <td style={{ textAlign: "left" }}>{nombre}</td>
        <td style={{ textAlign: "center" }}>--</td>
        <td style={{ textAlign: "center" }}>--</td>
        <td style={{ textAlign: "center" }}>--</td>
        <td style={{ textAlign: "center" }}>--</td>
        <td style={{ textAlign: "center" }}>{clienteAbonoQuincenal}</td>
        <td style={{ textAlign: "center" }}>{clienteNoAbono}</td>
        <td style={{ textAlign: "center" }}>{clienteTotalAbonado}</td>
        <td style={{ textAlign: "center" }}>{clienteTotalPendiente}</td>
        <td style={{ textAlign: "center" }}>{clientePagoQuincena}</td>
        <td style={{ textAlign: "center" }}>{clienteComision}</td>
        <td style={{ textAlign: "center" }}>{clienteNuevoSaldo}</td>

        <td className="d-flex" style={{ flexDirection: "column", gap: "5px" }}>
          <div className="">
            <button
              type="button"
              className="btn "
              data-bs-toggle="dropdown"
              aria-expanded="false"
              style={{ borderColor: "transparent" }}
              onClick={(e) => {
                e.stopPropagation(); // Stops bubbling up
                e.preventDefault(); // Stops default browser behavior
              }}
            >
              <HiDotsVertical />
            </button>
            <ul className="dropdown-menu">
              <li>
                <a
                  className="dropdown-item"
                  href="#"
                  onClick={(event) => {
                    abonarCliente?.(event, cobranzaItem || interestItems);
                    //abonarProducto?.(event, cobranzaItem, null)
                  }}
                  disabled={disableClienteAbonar}
                >
                  <GiPayMoney size={25} style={{ marginRight: "10px" }} />
                  Abonar
                </a>
              </li>

              <li>
                <hr className="dropdown-divider" />
              </li>
            </ul>
          </div>
        </td>
      </tr>

      {productoParcialidadesItems?.map((productoParcialidad, index) => {
        //const cliente = productoParcialidadCliente.cliente;

        return (
          <CobranzaConciliacionProductosCell
            key={productoParcialidad.id}
            innerRef={(el) => {
              tDetalleRef.current[index] = el;
              console.log(`--der ${index} ${tDetalleRef.current[index]}`);
            }}
            style={displayDetalle}
            productoParcialidad={productoParcialidad}
            cobranzaItem={cobranzaItem}
            abonarProducto={(event) => {
              abonarProducto?.(event, cobranzaItem, productoParcialidad);
            }}
          />
        );
      })}
    </>
  );
}

export default CobranzaConciliacionClientesCell;
